import GetWidgetClassInfoRequestModelBase from '../_generated/modelBases/get-widget-class-info-request-model-base';

export default class GetWidgetClassInfoRequestModel extends GetWidgetClassInfoRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
